angular.module('rjmNg.controllers').controller('dashParentCtrl', [
  "$scope"
  "$location"
  "app"
  "notification"
  "$url"
  "$modal"
  # this is here so that we can enable intercom if applicable
  (
    $scope
    $location
    app
    notification
    $url
    $modal
  ) ->

    $scope.app = app
    $scope.bodyStyle = 'rj-main-body'
    $scope.isTouring = false

    $scope.$on('isTouring', (event, touringState) ->
      $scope.isTouring = touringState
    )

    setPasswordModal = ->
      $modalScope = $scope.$new()

      modal = $modal(
        template: 'modal.setPassword.html'
        show: true
        backdrop: 'static'
        keyboard: false
        scope: $modalScope
        priority: 10
        modalClass: 'rj-modal'
      )
    
    _setBodyStyle = () ->
      if($scope.isANewChromeSettingsPage())
        $scope.bodyStyle = 'rj-settings-body'
      else
        $scope.bodyStyle = 'rj-main-body'

    if app.userNeedsPasswordReset()
      setPasswordModal()

    SETTINGS_PAGE_MATCHER = [
      "connection"
      "data-warehouse"
      "datatarget"
      "emailsummary"
      "export-api"
      "metric"
      "filter-set"
      "personal"
      "questions"
      "relationships"
      "relax"
      "systemsummary"
      "timezone"
      "upload"
      "raw-export"
      "persistent-views"
      "paths"
      "manage-reports"
      "email-summary"
    ].join('|')

    $scope.isANewChromeSettingsPage = ->
      return new RegExp(SETTINGS_PAGE_MATCHER, "ig").test($location.$$path)


    #clear the error message when changing the route
    $scope.$on "$routeChangeSuccess", (e, cur, prev) ->
      notification.clear("global")
      _setBodyStyle()

])
